import React, {
    useEffect,
    useState,
} from "react";

import {
    Navigate,
} from "react-router-dom";

import api from "./api";


export default function ProtectedAdminRoute({
    children,
}) {

    const [loading, setLoading] =
        useState(true);

    const [
        authenticated,
        setAuthenticated,
    ] = useState(false);


    useEffect(() => {

        const checkAdmin =
            async () => {

                try {

                    await api.get(
                        "admin-auth/me"
                    );

                    setAuthenticated(true);

                } catch {

                    setAuthenticated(false);

                } finally {

                    setLoading(false);
                }
            };


        checkAdmin();

    }, []);


    if (loading) {

        return (
            <div>
                Loading...
            </div>
        );
    }


    if (!authenticated) {

        return (
            <Navigate
                to="/admin-login"
                replace
            />
        );
    }


    return children;
}